/**
 * A retired alias route (R07, wave W0) answers with a redirect to the canonical one, so
 * a notification written before the retirement still lands where it meant to.
 *
 * Author: Mahmoud Ragab Ahmed.
 */

import { Navigate, useLocation } from "react-router";

import { canonicalPath } from "./deepLinks";

export function AliasRedirect(): React.JSX.Element {
  const location = useLocation();
  return <Navigate to={`${canonicalPath(location.pathname)}${location.search}`} replace />;
}
